import BlueArrowButton from '../buttons/blue-arrow-button';

export default function ActivityItemNew({ icon = true, title, type = null, subtitle, body, link, className, onClick = null }) {
    let props = {}

    if (onClick !== null) {
        props.style = {
            cursor: 'pointer',
        }

        props.onClick = onClick;
    }

    return (
        <div className={`${className} activity-item-new ${type !== null ? `activity-item-new--${type}` : ''}`} { ...props }>
            { icon && <svg xmlns="http://www.w3.org/2000/svg" width="38" height="35.786" viewBox="0 0 38 35.786">
                <path id="Path_321" data-name="Path 321" d="M4.455,33.383V9.328a1.807,1.807,0,0,1,1.137-1.7L22.3,1.268a.831.831,0,0,1,.791.109.918.918,0,0,1,.368.741v8.958l10.909,3.807A1.8,1.8,0,0,1,35.545,16.6V33.383H39V37H1V33.383Zm3.455,0H20V5.991L7.909,10.6Zm24.182,0V17.9l-8.636-3.015V33.383Z" transform="translate(-1 -1.214)" fill="#f5f8fa"/>
            </svg> }

            <div className="activity-item-new__content">
                { subtitle && <div className="activity-item-new__top">
                    { subtitle }
                </div> }
                { title && <div className="activity-item-new__title">
                    {title}
                </div> }
                { body && <div className="activity-item-new__body">
                    { body }
                </div> }
            </div>
            { link && <div className="activity-item-new__button-wrapper">
                <BlueArrowButton onClick={() => window.location = link}/>
            </div> }
        </div>
    );

}
